export default __webpack_public_path__ + "static/media/slider2.3fcd79b0.png";